import { TRAINING_TYPE } from '@lumapps/learning/types';
import { AspectRatio, Size } from '@lumapps/lumx/react';

import type { LearningResources } from './types';

export const LINK_PREVIEW = 'link-preview';

/**
 * Types of resources that can be included in the rich text editor
 *
 * /!\ when updating this enum, you HAVE to update also NotificationTargetType in analytics/analytics-tracking package as well
 * since it's a copy of this one (in order to avoid circular dependencies)
 */
export enum LINK_PREVIEW_RESOURCE_TYPES {
    ARTICLE = 'article',
    COMMUNITY = 'community',
    CONTENT = 'content',
    EVENT = 'event',
    LEARNING_PATH = 'learning_path',
    MICRO_APP = 'micro_app',
    PLAY_VIDEO = 'play_video',
    PLAY_VIDEO_PLAYLIST = 'play_video_playlist',
    POST = 'post',
    RECOMMENDATION_QUIZ = 'recommendation_quiz',
    SCORM_TRAINING = 'scorm_training',
    TRAINING_COURSE = 'training_course',
}

/** Max length of a link preview description */
export const PREVIEW_MAX_LENGTH = 120;

export const EXTERNAL_RESOURCE_IMG_CONFIG = {
    aspectRatio: AspectRatio.horizontal,
    size: Size.xl,
};

// Mapper to translate TRAINING_TYPE into LearningResources
export const LEARNING_TYPES_TO_RESOURCE_PREVIEW_TYPES: Record<TRAINING_TYPE, LearningResources> = {
    [TRAINING_TYPE.LEARNING_PATH]: LINK_PREVIEW_RESOURCE_TYPES.LEARNING_PATH,
    [TRAINING_TYPE.TRAINING]: LINK_PREVIEW_RESOURCE_TYPES.TRAINING_COURSE,
    [TRAINING_TYPE.RECOMMENDATION_QUIZ]: LINK_PREVIEW_RESOURCE_TYPES.RECOMMENDATION_QUIZ,
    [TRAINING_TYPE.SCORM_TRAINING]: LINK_PREVIEW_RESOURCE_TYPES.SCORM_TRAINING,
};
